import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

export default class UniprotPdbLinksComponent extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isExpanded: false,
    };

    this.truncateAfter = 10;
  }

  setExpanded(isExpanded) {
    this.setState({ isExpanded });
  }

  getTrackingAttrs() {
    return {
      ...this.props.trackingAttrs,
      'data-tracking-type': 'linkout',
      'data-tracking-action': this.props.trackingAction,
    };
  }

  render() {
    const linksArr = map(this.props.links, (value, key) => ({ key, value }));
    const { isExpanded } = this.state;
    const { heading, headingClass, useShowMore, proteinType, useSemicolon } = this.props;
    const externalIdsWrapperClass = proteinType === 'single' ? 'target-external-ids-wrapper' : '';
    const more = Math.max(0, linksArr.length - this.truncateAfter);
    let items = null;
    if (useShowMore) {
      items = isExpanded ? linksArr : linksArr.slice(0, linksArr.length - more);
    } else {
      items = linksArr;
    }

    return (
      <>
        <span className={`target-external-title ${headingClass}`}>{heading}:&nbsp;</span>
        <span className={externalIdsWrapperClass}>
          {map(items, (item, i) => (
            <a
              key={i}
              className='target-external-ids no-animate'
              href={item.value}
              target='_blank'
              {...this.getTrackingAttrs()}>
              {item.key}
              {i < items.length - 1 || (more > 0 && !isExpanded)}

              {items.length - 1 === i && useSemicolon && <span>;</span>}
            </a>
          ))}
        </span>

        {/*Show more functionality should not be applied inside extended details*/}
        {useShowMore && (
          <>
            {more > 0 && !isExpanded && (
              <span
                role='button'
                tabIndex='0'
                className='target-external-ids no-animate'
                onClick={() => this.setExpanded(true)}>
                + {more} more
              </span>
            )}

            {isExpanded && (
              <span
                role='button'
                tabIndex='0'
                className='target-external-ids no-animate'
                onClick={() => this.setExpanded(false)}>
                - show less
              </span>
            )}
          </>
        )}
      </>
    );
  }
}

UniprotPdbLinksComponent.propTypes = {
  links: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  headingClass: PropTypes.string.isRequired,
  useShowMore: PropTypes.bool.isRequired,
  trackingAction: PropTypes.string.isRequired,
  proteinType: PropTypes.string.isRequired,
  useSemicolon: PropTypes.bool.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};
